import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin, Youtube } from "lucide-react";
import { Monogram } from "./common";
import { useSite } from "../context/SiteContext";
import { COMPANY, ADDRESS, WEBSITE, mediaUrl } from "../lib/api";

const LINKS = [
  ["About Us", "/about"], ["Projects", "/projects"], ["Krishna Vatika", "/krishna-vatika"], ["Contact Us", "/contact"],
  ["Privacy Policy", "/privacy-policy"], ["Terms & Conditions", "/terms"], ["Disclaimer", "/disclaimer"],
];
const SOCIAL = { facebook: Facebook, instagram: Instagram, linkedin: Linkedin, youtube: Youtube };

export function Footer() {
  const { settings } = useSite();
  const rera = settings.rera || {};
  const socials = Object.entries(settings.social || {}).filter(([, v]) => v);
  return (
    <footer className="relative bg-emerald-900 text-ivory grain pb-20 lg:pb-0" data-testid="site-footer">
      <div className="container-x relative py-16 sm:py-20 grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3">
            <Monogram light />
            <span className="font-serif text-xl font-semibold">{COMPANY}</span>
          </div>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-ivory/70" data-testid="footer-address">{settings.address || ADDRESS}</p>
          <a href={`https://${WEBSITE}`} className="mt-3 inline-block text-sm text-gold hover:text-gold-400 transition-colors" data-testid="footer-website">{WEBSITE}</a>
          {settings.phone && <p className="mt-3 text-sm text-ivory/70"><a href={`tel:${settings.phone}`} data-testid="footer-phone">{settings.phone}</a></p>}
          {settings.email && <p className="mt-1 text-sm text-ivory/70"><a href={`mailto:${settings.email}`} data-testid="footer-email">{settings.email}</a></p>}
          {socials.length > 0 && (
            <div className="mt-6 flex gap-4" data-testid="footer-social">
              {socials.map(([k, v]) => { const I = SOCIAL[k]; return I ? <a key={k} href={v} target="_blank" rel="noreferrer" className="text-ivory/75 hover:text-gold transition-colors" aria-label={k}><I size={18} /></a> : null; })}
            </div>
          )}
        </div>
        <div className="lg:col-span-4">
          <p className="eyebrow !text-gold">Navigate</p>
          <ul className="mt-6 grid grid-cols-2 gap-x-6 gap-y-3">
            {LINKS.map(([l, to]) => <li key={to}><Link to={to} className="text-sm text-ivory/75 hover:text-gold transition-colors" data-testid={`footer-link-${l.toLowerCase().replace(/[^a-z]+/g, "-")}`}>{l}</Link></li>)}
          </ul>
        </div>
        <div className="lg:col-span-3">
          {rera.enabled && rera.number && (
            <div data-testid="footer-rera">
              <p className="eyebrow !text-gold">RERA</p>
              <p className="mt-4 text-sm text-ivory/80">Registration No. {rera.number}</p>
              {rera.url && <a href={rera.url} target="_blank" rel="noreferrer" className="text-sm text-gold hover:text-gold-400">View on RERA portal</a>}
              {rera.qr_image_url && <img src={mediaUrl(rera.qr_image_url)} alt="RERA QR" className="mt-3 h-24 w-24 bg-white p-1" />}
            </div>
          )}
          <p className="mt-6 text-xs text-ivory/75 leading-relaxed">Krishna Vatika · Premium Residential Plots · A Project by {COMPANY}</p>
        </div>
      </div>
      <div className="border-t border-gold/20">
        <div className="container-x py-6 text-center text-xs text-ivory/75" data-testid="footer-copyright">© 2026 M & S Green Estate Pvt. Ltd. All Rights Reserved.</div>
      </div>
    </footer>
  );
}
